// Copyright (c) 2018 Comsearch, Inc., All rights reserved

const getPrimaryAntennaCode = antennas => {
  // NOTE - this grabs the first Primary antenna. There may be more than one
  // Primary for this segment end but it will be displayed as
  // an 'additional antenna' within a tooltip like any diversity antennas.
  const primaryAntenna = antennas.find(d => d.antennaType === 'Primary')

  const {
    antennaCode = null,
    modelNumber = null,
  } = primaryAntenna || {}

  return ({
    antennaCode,
    modelNumber,
  })
}

export default getPrimaryAntennaCode
